/**
 * Detecta el origen de un ticket (D1-D6) para el chip del topbar.
 *
 * Reglas en orden de prioridad:
 *   D6 Vinculada    parent_id && incidence
 *   D3 AuditCam     audit_cam === true
 *   D5 Bot semanal  sin owner humano + cuestionario semanal (props.ticket_answer pre-cargado)
 *   D4 Bot diario   sin owner humano + sin cuestionario
 *   D2 Auditoría    cuestionario secundario presente (owner humano)
 *   D1 Manual       fallback
 *
 * Retorna: { key, labelKey, fallbackLabel, iconName, dotClass, bgClass, textClass }
 */

const ORIGIN = {
    D1: {
        key: 'D1',
        labelKey: 'origin_manual',
        fallbackLabel: 'Manual',
        iconName: 'HiOutlineUser',
        dotClass: 'bg-gray-400',
        bgClass: 'bg-gray-100 dark:bg-gray-700',
        textClass: 'text-gray-700 dark:text-gray-200',
    },
    D2: {
        key: 'D2',
        labelKey: 'origin_audit',
        fallbackLabel: 'Auditoría',
        iconName: 'HiOutlineClipboardCheck',
        dotClass: 'bg-indigo-500',
        bgClass: 'bg-indigo-50 dark:bg-indigo-900/30',
        textClass: 'text-indigo-700 dark:text-indigo-300',
    },
    D3: {
        key: 'D3',
        labelKey: 'origin_auditcam',
        fallbackLabel: 'AuditCam',
        iconName: 'HiOutlineVideoCamera',
        dotClass: 'bg-indigo-500',
        bgClass: 'bg-indigo-50 dark:bg-indigo-900/30',
        textClass: 'text-indigo-700 dark:text-indigo-300',
    },
    D4: {
        key: 'D4',
        labelKey: 'origin_bot_daily',
        fallbackLabel: 'Automático',
        iconName: 'HiOutlineBell',
        dotClass: 'bg-indigo-500',
        bgClass: 'bg-indigo-50 dark:bg-indigo-900/30',
        textClass: 'text-indigo-700 dark:text-indigo-300',
    },
    D5: {
        key: 'D5',
        labelKey: 'origin_bot_weekly',
        fallbackLabel: 'KPI',
        iconName: 'HiOutlineChartBar',
        dotClass: 'bg-indigo-500',
        bgClass: 'bg-indigo-50 dark:bg-indigo-900/30',
        textClass: 'text-indigo-700 dark:text-indigo-300',
    },
    D6: {
        key: 'D6',
        labelKey: 'origin_linked',
        fallbackLabel: 'Vinculada',
        iconName: 'HiOutlineLink',
        dotClass: 'bg-indigo-500',
        bgClass: 'bg-indigo-50 dark:bg-indigo-900/30',
        textClass: 'text-indigo-700 dark:text-indigo-300',
    },
}

const isHumanOwner = (owner) => {
    if (!owner) return false
    const name = `${owner?.name || ''} ${owner?.lastname || ''}`.toLowerCase()
    if (!name.trim()) return false
    return !/(bot|sistema|sys|storehub bot|n8n|automation)/i.test(name)
}

const detectOrigin = (ticket) => {
    if (!ticket) return ORIGIN.D1

    const { parent_id, incidence, audit_cam, props } = ticket
    const owner = props?.owner || ticket.owner
    const ticketCategorySecondary =
        props?.ticket_category_secondary || ticket.ticket_category_secondary
    // El back puede entregar `question_group_secondary` como objeto hidratado
    // o como array (segun endpoint). Aceptamos ambos.
    const secondaryGroup = ticketCategorySecondary?.question_group_secondary
    const hasSecondaryGroup = Array.isArray(secondaryGroup)
        ? secondaryGroup.length > 0
        : Boolean(secondaryGroup)
    const hasQuestionnaire = Boolean(
        ticketCategorySecondary?.question_group_secondary_id || hasSecondaryGroup
    )
    const ownerIsHuman = isHumanOwner(owner)

    if (parent_id && incidence) return ORIGIN.D6
    if (audit_cam) return ORIGIN.D3
    if (!ownerIsHuman && hasQuestionnaire) return ORIGIN.D5
    if (!ownerIsHuman) return ORIGIN.D4
    if (hasQuestionnaire) return ORIGIN.D2
    return ORIGIN.D1
}

export { ORIGIN }
export default detectOrigin
